import { useEffect, useState } from 'react'

import CONFIG from '../../config'
import { AuthRoles } from '../models'
import { authService, notifyService } from '../services'

const useNotify = (role: AuthRoles) => {
  const [notifications, setNotifications] = useState<any[] | null>(null)

  useEffect(() => {
    if(authService.isLoggedIn() && role !== CONFIG.AUTH.ROLES.ADMIN) getNotifications()
  }, [role])

  const getNotifications = async () => {
    const resp = await notifyService.getNotifications()
    setNotifications(resp.data && resp.data.notifications ? resp.data.notifications : [])
  }

  const getNotificationsNewCount = () => {
    const notificationsCount = notifications && notifications.filter((it: any) => it.notification_read === false)
    return notificationsCount && notificationsCount.length
  }

  const setNotificationRead = (id: number) => {
    const notificationsRead = notifications && notifications.map((it: any) => {
      return (it.id === id ?
          {
            ...it,
            notification_read: true
          }
        :
          it
      )
    })
    setNotifications(notificationsRead)
  }

  return {
    notifications,
    getNotificationsNewCount,
    getNotifications,
    setNotificationRead
  }
}

export { useNotify }